import React from 'react'
import { SwiperSlide } from 'swiper/react'
import styled from 'styled-components'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import FeatureTourIntroCard from 'pages/shared/FeatureTourModal/FeatureTourIntroCard'

import Carousel from 'components/Carousel'

import { removeScriptTags } from 'helpers/formatters'
import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

import { SiteMessageDetail } from 'types/SiteMessageDetail'

type Props = {
  title: string
  message: string
  siteMessages: Array<SiteMessageDetail>
  closeCallback: (string) => void
}

const FeatureTourCarousel = ({
  title,
  message,
  siteMessages,
  closeCallback
}: Props) => {
  return (
    <Carousel closeCallback={closeCallback}>
      <SwiperSlide key="intro-slide">
        <FeatureTourIntroCard
          title={title}
          message={message}
          siteMessages={siteMessages}
        />
      </SwiperSlide>
      {siteMessages.map((siteMessage) => (
        <SwiperSlide key={siteMessage.id}>
          <S.Container>
            <S.TopSection>
              {siteMessage.image && (
                <S.ImageWrapper>
                  <S.Image
                    src={siteMessage.image}
                    style={{ objectFit: 'unset' }}
                  />
                </S.ImageWrapper>
              )}
              <S.ContentWrapper>
                <S.Heading>{siteMessage.title}</S.Heading>
                <br />

                {siteMessage.actionButtonLink && (
                  <a
                    href={siteMessage.actionButtonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button
                      decoration="secondary"
                      text={siteMessage.actionButtonCaption}
                    />
                  </a>
                )}
              </S.ContentWrapper>
            </S.TopSection>
            <S.MessageWrapper>
              <S.Message
                dangerouslySetInnerHTML={{
                  __html: removeScriptTags(siteMessage.message)
                }}
              />
            </S.MessageWrapper>
          </S.Container>
        </SwiperSlide>
      ))}
    </Carousel>
  )
}

export default FeatureTourCarousel

const S = {
  Container: styled.div`
    padding: 20px;
    width: 100%;
    @media ${screenSize.small} {
      padding: 10px 0;
    }
  `,
  TopSection: styled.div`
    display: flex;

    gap: 30px;
    @media ${screenSize.small} {
      flex-direction: column;
      padding-top: 15px;
      gap: 20px;
    }
  `,
  ImageWrapper: styled.div`
    width: 50%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media ${screenSize.small} {
      width: 100%;
      margin-bottom: 10px;
    }
  `,
  ContentWrapper: styled.div`
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;

    @media ${screenSize.small} {
      width: 100%;
    }
  `,
  Heading: styled.h2`
    color: ${color('featureToursHeading')};
    margin-top: 0;
  `,
  Link: styled.a`
    color: ${color('featureToursSiteLink')};
    word-break: break-word;
  `,
  Image: styled.img`
    border-radius: 8px;
    background-color: ${color('featureToursActiveBackground')};
  `,
  MessageWrapper: styled.div`
    text-align: left;
  `,
  Message: styled.p`
    color: ${color('primaryText')};
    font-size: 16px;
    line-height: 1.5;
  `
}
